import {DataSource} from "@/datasources/consulte-grid";
import {BibUsuarioModel} from '@/models/biblioteca/bibusuario/bibusuario.model';
import BibUsuarioService from "@/services/biblioteca/bibusuario/bibusuario.service";

export default class BibUsuarioDataSource extends DataSource<BibUsuarioModel> {
 gesEscolaId?: number;

 constructor(
  pageNumber: number,
  rowsPerPage: number,
  rowsPageCount: number,
  totalRowCount: number,
  Rows: BibUsuarioModel[],
  gesEscolaId?: number,
  onLoad?: (rows: any) => void
 ) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<BibUsuarioModel>())
  this.gesEscolaId = gesEscolaId;
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await BibUsuarioService.dadosIndexPaginado(
   this.pageNumber,
   this.rowsPerPage,
   this.filters,
   this.gesEscolaId
  )).data as any) as DataSource<BibUsuarioModel>;
  console.log(result);
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
